import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { setCookie, getCookie } from 'modules/Utils';

interface AdminState {
    // state
    showIds: boolean;

    // actions
    setShowIds: (showIds: boolean) => void;
}

const useAdmin = create(immer<AdminState>((set) => ({
    // state
    showIds: getCookie('showIds') === 'true',

    // actions
    setShowIds: (showIds: boolean) => {
        setCookie('showIds', showIds.toString());
        set({ showIds });
    },
})));

export default useAdmin;
